module.exports = __webpack_public_path__ + "static/media/hsr.26223fea.svg";